(() => {
  const configElement = document.getElementById('mm-campaign-offer-config');
  if (!configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Campaign offer configuration could not be read.', error);
    return;
  }

  const offer = String(config.offer || '').toLowerCase();
  const storageKey = `mm_campaign_offer_${offer}`;
  const expiresAt = Date.parse(config.expiresAt);
  const requestedOffer = new URLSearchParams(window.location.search).get('offer');
  const normalizedRequest = requestedOffer ? requestedOffer.toLowerCase() : '';
  const activeDiscountCode = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith('discount_code='))
    ?.split('=')
    .slice(1)
    .join('=');
  const hasCampaignDiscount = activeDiscountCode
    && decodeURIComponent(activeDiscountCode).toLowerCase() === String(config.discountCode).toLowerCase();

  const readStoredOffer = () => {
    try {
      return window.sessionStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  const storeOffer = () => {
    try {
      window.sessionStorage.setItem(storageKey, config.expiresAt);
    } catch (error) {
      // The URL marker still activates the offer when browser storage is unavailable.
    }
  };

  const clearOffer = () => {
    try {
      window.sessionStorage.removeItem(storageKey);
    } catch (error) {
      // Nothing else is required when browser storage is unavailable.
    }
  };

  if (!Number.isFinite(expiresAt) || Date.now() >= expiresAt) {
    clearOffer();
    return;
  }

  if (requestedOffer) {
    if (normalizedRequest !== offer) {
      clearOffer();
      return;
    }
    storeOffer();
  } else if (hasCampaignDiscount) {
    storeOffer();
  } else if (readStoredOffer() !== config.expiresAt) {
    return;
  }

  document.documentElement.classList.add('mm-offer-active');

  const createPriceElement = (tagName, className, text) => {
    const element = document.createElement(tagName);
    element.className = className;
    element.textContent = text;
    return element;
  };

  const populatePrice = (container, taxText = '') => {
    container.replaceChildren(
      createPriceElement('s', 'mm-campaign-price__regular', config.regularPrice),
      createPriceElement('strong', 'mm-campaign-price__current', config.offerPrice),
      createPriceElement('em', 'mm-campaign-price__badge', `-${config.discountPercent}%`)
    );

    if (taxText) {
      container.append(createPriceElement('span', 'mm-campaign-price__tax', taxText));
    }
  };

  const createOfferNote = () => {
    const note = document.createElement('p');
    note.className = 'mm-campaign-offer__note';
    note.append('Dein Aktionspreis mit Code ');
    note.append(createPriceElement('strong', '', config.discountCode));
    note.append(` · gültig bis ${config.expiresLabel}`);
    return note;
  };

  const applyTopPrice = () => {
    const priceHost = document.querySelector('[id^="price-"]');
    if (!priceHost) return;

    const originalPrice = priceHost.querySelector('.price');
    if (originalPrice) {
      originalPrice.hidden = true;
      originalPrice.setAttribute('aria-hidden', 'true');
    }

    let campaignPrice = priceHost.querySelector('.mm-campaign-price');
    if (!campaignPrice) {
      campaignPrice = document.createElement('div');
      campaignPrice.className = 'mm-campaign-price';
      priceHost.append(campaignPrice);
    }
    populatePrice(campaignPrice);

    let note = priceHost.querySelector('.mm-campaign-offer__note');
    if (!note) {
      note = createOfferNote();
      priceHost.append(note);
    }
  };

  const applyAdditionalPrices = () => {
    document.querySelectorAll('.mm-fusion-final-buy__price').forEach((price) => {
      populatePrice(price);
      if (!price.nextElementSibling?.classList.contains('mm-campaign-offer__note')) {
        const note = createOfferNote();
        note.classList.add('mm-campaign-offer__note--compact');
        price.after(note);
      }
    });

    document.querySelectorAll('.mm-fusion-inline-cta__price').forEach((price) => {
      const taxText = price.querySelector('.mm-campaign-price__tax')?.textContent
        || price.querySelector('span')?.textContent
        || 'inkl. Steuern.';
      populatePrice(price, taxText);
      if (!price.nextElementSibling?.classList.contains('mm-campaign-offer__note')) {
        const note = createOfferNote();
        note.classList.add('mm-campaign-offer__note--compact');
        price.after(note);
      }
    });
  };

  const applyButtons = () => {
    const label = 'Jetzt Fusion lernen';

    document.querySelectorAll('.product-form__submit').forEach((button) => {
      const labelElement = button.querySelector('span');
      if (labelElement && !button.disabled) labelElement.textContent = label;
    });

    document
      .querySelectorAll('.mm-fusion-final-buy__button, .mm-fusion-inline-cta__button')
      .forEach((button) => {
        if (!button.disabled) button.textContent = label;
      });
  };

  const applyCheckoutRoute = () => {
    document
      .querySelectorAll(
        'product-form form[action*="/cart/add"], .mm-fusion-final-buy__form, .mm-fusion-inline-cta__form'
      )
      .forEach((form) => {
        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          form.append(returnTo);
        }
        returnTo.value = config.checkoutPath;
      });
  };

  const applyOffer = () => {
    applyTopPrice();
    applyAdditionalPrices();
    applyButtons();
    applyCheckoutRoute();
  };

  applyOffer();
  document.addEventListener('shopify:section:load', applyOffer);
})();
